import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GenericDropDownV3, SimpleListAdapter, TS_DropDown, TS_MultiSelect_V2 } from '@nu-art/thunderstorm-frontend/index';
import { TimezoneIdentifiers } from '@app/org-shared';
import { ModuleFE_Facility } from './ModuleFE_Facility.js';
import { DBItemDropDownMultiSelector } from '@nu-art/thunderstorm-frontend/components/_TS_MultiSelect/DBItemDropDownMultiSelector';
import { ICONS, QuaiManager_DropDownCaret } from '@app/styles';
import { Filter } from '@nu-art/ts-common';
const Props_DropDown = {
    module: ModuleFE_Facility,
    modules: [ModuleFE_Facility],
    mapper: item => [item.name],
    placeholder: 'Choose a Facility',
    renderer: item => _jsx(_Fragment, { children: item.name })
};
export const DropDown_Facility = GenericDropDownV3.prepare(Props_DropDown);
const Props_MultiSelect = DBItemDropDownMultiSelector.propsV3({
    module: ModuleFE_Facility,
    itemRenderer: (item, onDelete) => {
        return !item ? _jsx(_Fragment, { children: "Not Found" }) : _jsxs(_Fragment, { children: [_jsx(ICONS.x.component, { onClick: onDelete }), item.name] });
    },
    uiSelector: DropDown_Facility.selectable,
});
export const MultiSelect_Facility = TS_MultiSelect_V2.prepare(Props_MultiSelect);
// Timezone Dropdown
export const Props_TimezoneDropDown = {
    adapter: () => SimpleListAdapter([...TimezoneIdentifiers], tz => _jsx(_Fragment, { children: tz.item })),
    placeholder: 'Select Timezone',
    caret: QuaiManager_DropDownCaret,
    filter: new Filter(tz => [tz]),
};
export const DropDown_Timezone = TS_DropDown.prepare(Props_TimezoneDropDown);
//# sourceMappingURL=ui-components.js.map